import styled from "styled-components";
import fontSize from "../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  font-size: ${fontSize.s};
  color: #ce1e1e;
  font-weight: 300;
`;
function ErrorMessage({ text }) {
  return <Wrapper>Error : {text}</Wrapper>;
}

export default ErrorMessage;
